import { Image, Text, View } from 'components';
import Base, { Config } from 'components/sixshot/Base';
import React from 'react';
import { history } from 'modules/navigator';
import STATIC from 'modules/static';
import styles from './index.module.scss';


interface State {
  column: string
  type: number
}
/**
 * type: 1 | 2       //1长期；  2替班
 * column: string    //表示对应的权利页面
 * ↓↓↓↓↓↓↓
 * score      -- 积分
 * law        -- 律师法务咨询
 * box        -- 云盒代理
 * course     -- 维修课程
 * fault      -- 故障查询
 * agent      -- 兼职代理
 * pact       -- 驾驶员合同
 * icon       -- 专属标识
 * insurance  -- 保险
 * quality    -- 专属优质工作推荐
 * **/
export default class VipCompaire extends Base<any, State> {
  public config: Config = {
    navigationBarTitleText: '会员特权'
  };

  public state: State = {
    column: '',
    type: 1  //默认长期会员， 2：替班会员
  };

  public async didMount() {
    // await this.getUserInfo();

    const params:any = this.navigator.getParams(' '+this.props.location.search) || {}
    const parmState = this.props.location.state || {}
    this.setState({
      column: params.column || parmState.column || '',
      type: params.type || parmState.type || 1,
    })
  }

  public render() {
    const { column, type } = this.state;

    return (
      <View className={styles.container}>
        
        {column == 'law' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceLaw.png'} />
          </View>
        }
        {column == 'box' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox0.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox1.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox2.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox3.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox4.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox5.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox6.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox7.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox8.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox9.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox10.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox11_1.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceBox12.png'} />
          </View>
        }
        {column == 'course' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceCourse1_3.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceCourse2_3.png'} />
          </View>
        }
        {column == 'fault' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceFault3.png'} />
          </View>
        }
        {column == 'agent' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent1.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent2.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent3.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent4.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent5.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent6.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgen7.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent8.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent9.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent10.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent11.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent12_1.png'} />
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceAgent13.png'} />
          </View>
        }
        {column == 'icon' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceIcon1.png'} />
          </View>
        }
        {column == 'insurance' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceInsurance2.png'} />
          </View>
        }
          
        {column == 'quality' && (
          type == 2? 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceInsuranceTi.png'} />
          </View> :
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/sixshot/introduceQuality1.png'} />
          </View>
        )}



        {column == 'rent_icon' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/rent/rentIntroduceIcon1.png'} />
          </View>
        }
        {column == 'rent_quality' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/rent/rentIntroduceQuality3.png'} />
          </View>
        }
        {column == 'rent_push' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/rent/rentIntroducePush.png'} />
          </View>
        }
        {column == 'rent_uploadVideo' && 
          <View className={styles.box}>
            <Image className={styles.img} src={STATIC.AssetsBase + '/rent/rentIntroduceUploadVideo1.png'} />
          </View>
        }
        
        
        

        
        <View className={styles.backBtn}>
          {column == 'insurance'? (
            <View className={styles.insuranceBtns}>
              <View className={styles.btn} onClick={this.handleClickInsurance}>{'想买更高保额更全面保险，点此咨询>>'}</View>  
              <View className={styles.back} onClick={this.handleBack}>{'<< 点此返回'}</View>  
            </View>
          ): (
            <View className={styles.btn} onClick={this.handleBack}>{'点此返回'}</View>  
          )}
        </View>
      </View>
    );
  }

  private handleBack = () => {
    if(this.interface.uaEnv.isWechatMp()){
      window.wx.miniProgram.navigateBack()
    }else if(this.interface.uaEnv.isReactNative) {
      this.interface.postMessage('back')
    }else {
      this.navigator.back()
    }
  }


  private handleClickInsurance = () => {
    history.push('/sixshot/vip/adviceApply')
  }
  
}

